export var ACTION;
(function (ACTION) {
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["NAVIGATION"] = "NAVIGATION";
    ACTION["EMAIL"] = "EMAIL";
    ACTION["ENHANCE_LIMIT"] = "ENHANCE_LIMIT";
    ACTION["MARGIN_CALL"] = "MARGIN_CALL";
    ACTION["MENU"] = "MENU";
    ACTION["NAVIGATE_UNPLEDGE"] = "NAVIGATE_UNPLEDGE";
    ACTION["VIEW_DETAILS"] = "VIEW_DETAILS";
    ACTION["NAVIGATE_TO_REMOVE_PLEDGE_STEPS"] = "NAVIGATE_TO_REMOVE_PLEDGE_STEPS";
    ACTION["NAVIGATE_TO_PLEDGE_HISTORY"] = "NAVIGATE_TO_PLEDGE_HISTORY";
    ACTION["CLOSE_ERROR_MODAL"] = "CLOSE_ERROR_MODAL";
})(ACTION || (ACTION = {}));
export var REQUEST_TYPE;
(function (REQUEST_TYPE) {
    REQUEST_TYPE["REVOCATION_REQUEST"] = "REVOCATION_REQUEST";
    REQUEST_TYPE["ENHANCE_LIMIT_REQUEST"] = "ENHANCE_LIMIT_REQUEST";
})(REQUEST_TYPE || (REQUEST_TYPE = {}));
